import type { QueryClient } from "@tanstack/react-query";
import type { McpServer } from "@/app/mcp-gateways/types";
import { jtbdsQueryOptions } from "@/app/onboarding-first-win/api/get-jtbds";
import type { OrgProjectScope } from "@/lib/resource-context";
import type {
  OnboardingProgress,
  OnboardingProgressResponse,
} from "../api/get-onboarding-progress";
import { onboardingKeys } from "../api/query-keys";
import { mapMcpServerToOnboardingGateway } from "./map-onboarding-gateway";

/**
 * Optimistically advance jtbd → connect in the progress cache using the
 * gateway returned from create. Reconcile with the BFF via
 * `useReconcileOnboardingProgress(created)` immediately after.
 */
export function patchProgressAfterGatewayCreate(
  queryClient: QueryClient,
  scope: OrgProjectScope,
  created: McpServer
): void {
  const progressKey = onboardingKeys.progress({ scope });
  const previous =
    queryClient.getQueryData<OnboardingProgressResponse>(progressKey);
  if (previous == null || previous.step !== "jtbd") {
    return;
  }

  const jtbds =
    queryClient.getQueryData(jtbdsQueryOptions().queryKey)?.jtbds ?? [];
  const updated: OnboardingProgress = {
    ...previous,
    step: "connect",
    gateway: mapMcpServerToOnboardingGateway(created, jtbds),
  };
  queryClient.setQueryData<OnboardingProgressResponse>(progressKey, updated);
}
